/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Usage_Never_Item_3Inputs */

const es_privacy_policy_usage_never_item_3 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear perfiles de usuario para marketing externo`)
};

const en_privacy_policy_usage_never_item_3 = /** @type {(inputs: Privacy_Policy_Usage_Never_Item_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating user profiles for external marketing`)
};

/**
* | output |
* | --- |
* | "Creating user profiles for external marketing" |
*
* @param {Privacy_Policy_Usage_Never_Item_3Inputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_usage_never_item_3 = /** @type {((inputs?: Privacy_Policy_Usage_Never_Item_3Inputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Usage_Never_Item_3Inputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_usage_never_item_3(inputs)
	return en_privacy_policy_usage_never_item_3(inputs)
});
export { privacy_policy_usage_never_item_3 as "privacy_policy.usage.never_item_3" }